export default "__VITE_ASSET__BzvE3hx8__"